import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { Box, Typography, Grid } from "@mui/material";
import { useSubscription } from "@apollo/client";
import { useSelector } from "react-redux";
import { API_PORTS_SUBSCRIPTION } from "../../graphql/query";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import DynamicTable from "../customComponents/DynamicTable";
import CustomTabs from "../customComponents/CustomTabs";
import CustomModal from "../customComponents/customModal";
import ExportExcel from "../buttonComponents/ExportExcel";
import * as XLSX from "xlsx";

const size = {
  //   width: 400,
  height: 190,
  // margin: { left: 80 },
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 20,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2} sx={{ fontSize: '15px', fontWeight: 500, color: '#979DAC' }}>
      {children}
    </StyledText>
  );
}


const ChargeUsageStatue = ({ facilityFilterID, facilityFilterName, facilityFilterAddress, showTitle, powerTypeFilter }) => {

  const { selectedFacility } = useSelector(state => state.stationList);
  const { appliedFilter } = useSelector(state => state.powerTypeFilter);

  const { data } = useSubscription(API_PORTS_SUBSCRIPTION, {
      variables: {
          "where": {
              ...(appliedFilter !== 'Both' && {
                "power_type" : {
                  "_eq": appliedFilter
                }
              }),
              "api_charger": {
                  "api_facility": { 
                      ...(selectedFacility?.id && {
                          "id" :{
                              "_in": [...(typeof selectedFacility?.id === 'number'? [selectedFacility?.id] : selectedFacility?.id)]
                          }
                      }),
                  }
              }
          }
      }
    }
  )

  const [portsData, setPortsData] = useState([{ label: '', value: 0 }]);
  const [totalChargers, setTotalChargers] = useState(0)

  const { t } = useTranslation();

  const [tab, setTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState(null)

  const mapTableData = (array) => {
    return array.map((p) => ({
            charger_name: p.api_charger.name,
            connector_id: p.connector_id,
            facility_name: p.api_charger.api_facility.name,
            port_status: p.port_status,
            updated_at: p.updated_at,
            ...(p.api_chargersessions.length > 0 && {
              user_name: p.api_chargersessions[0].api_user.name,
              token: p.api_chargersessions[0].api_user.token,
              transaction_id: p.api_chargersessions[0].transaction_id,
              session_id: p.api_chargersessions[0].session_id,
            })
          })) 
  }

  useEffect(() => {
    if (data?.api_chargerport) {
      setTotalChargers(data?.api_chargerport.length)
      setPortsData([
        { 
          label: 'Available', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Available').length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Available')) 
        },
        { 
          label: 'Preparing', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Preparing').length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Preparing'))
        },
        { 
          label: 'Charging', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Charging').length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Charging'))  
        },
        { 
          label: 'Finishing', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Finishing').length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Finishing'))   
        },
        { 
          label: 'Faulted', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Faulted').length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected && p.port_status === 'Faulted'))   
        },
        { 
          label: 'Offline', 
          value: data.api_chargerport.filter((p) => p.api_charger.is_connected === false).length, 
          table: mapTableData(data.api_chargerport.filter((p) => p.api_charger.is_connected === false)) 
        }
      ])
    }
  }, [data])

  useEffect(() => {
      formateTableData(portsData)
  }, [portsData])

  const openStatusModal = (e, d) => {
    setTab(d.dataIndex);
    setOpenModal(true);
  }

  function formatDate(date) {
    let dd = String(date.getDate()).padStart(2, '0');
    let mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    let yyyy = date.getFullYear();
    let hh = String(date.getHours()).padStart(2, '0');
    let min = String(date.getMinutes()).padStart(2, '0');
    let ss = String(date.getSeconds()).padStart(2, '0');

    return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
  }


  const formateTableData = (toFormateData) => {

    const formateData = (content, type) => {
      if (type !== "Charging" && type !== "Finishing")
        return content?.map(item => ({
          charger_name: item?.charger_name,
          connector_id: item?.connector_id,
          facility_name: item?.facility_name,
          last_updated_at: item?.updated_at ? formatDate(new Date(item?.updated_at)) : ''
        }))
      return content?.map(item => ({
        charger_name: item?.charger_name,
        connector_id: item?.connector_id,
        facility_name: item?.facility_name,
        user_name: item?.user_name,
        transaction_id: item?.transaction_id,
        last_updated_at: item?.updated_at ? formatDate(new Date(item?.updated_at)) : '',
        session_id: item?.session_id,
        login: {
          target: "_blank",
          type: "button",
          api: `${process.env.REACT_APP_WEBAPP_URL}charger-status/${item?.session_id}?token=${item?.token}`,
          label: "Open"
        }
      }))
    }

    const headers = [
      { label: 'charger', id: 'charger_name' },
      { label: 'connector id', id: 'connector_id' },
      { label: 'facility', id: 'facility_name' },
      { label: 'last updated at', id: 'last_updated_at' },
    ]

    const chargingAndFinishingHeader = [
      { label: 'charger', id: 'charger_name' },
      { label: 'connector id', id: 'connector_id' },
      { label: 'facility', id: 'facility_name' },
      { label: 'transaction id', id: 'transaction_id' },
      { label: 'session id', id: 'session_id' },
      { label: 'user name', id: 'user_name' },
      { label: 'last updated at', id: 'last_updated_at' },
      { label: 'open', id: 'login' }
    ]

    setTableData({
      type: "table",
      name: null,
      tabs: toFormateData.map(item => ({
        name: item.label,
        headers: item.label !== "Charging" && item.label !== "Finishing" ? headers : chargingAndFinishingHeader,
        table_content: formateData(item.table, item.label),
        count: item.table?.length ?? 0
      }))
    })
  }

  const handleExportExcel = () => {
    if (!tableData || !tableData?.tabs) return;
    const workbook = XLSX.utils.book_new(); 
    tableData?.tabs?.forEach((tab) => {
      if (tab.table_content?.length > 0) {
        const filteredData = tab.table_content.map(({ charger_name, connector_id, facility_name, last_updated_at }) => ({
          charger: charger_name,
          "connector id": connector_id,
          facility: facility_name,
          "last updated at": last_updated_at,
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredData); 
        XLSX.utils.book_append_sheet(workbook, worksheet, tab.name); 
      }
    });
    if(workbook.SheetNames?.length > 0)
    XLSX.writeFile(workbook, `ChargerStatus_AllTabs.xlsx`); 
  };

  return (
    <>
      <Box bgcolor={"white"} borderRadius={"16px"} padding={"15px"}>
        <Box>
          {showTitle ? (
            <>
              <Typography variant="h5" color={"primary"} sx={{ textTransform: 'capitalize', fontWeight: '600', fontSize: '16px' }}>{facilityFilterName}</Typography>
              <Typography variant="body1" color={"gray"} sx={{ textTransform: 'capitalize', fontSize: '10px' }}>{facilityFilterAddress}</Typography>
            </>
          ) : (
            <Typography sx={{ textTransform: 'capitalize', fontWeight: '600' }}>{t('chargerStatus')}</Typography>

          )}
        </Box>
        <Box style={{ padding: "22px 0px" }}>
          {portsData && (<PieChart
            series={[{ data: portsData, innerRadius: 66, outerRadius: 76 }]}
            slotProps={{
              // legend: { hidden: true },
            }}
            onClick={openStatusModal}
            {...size}
          >
            <PieCenterLabel>{totalChargers} {t('chargers')}</PieCenterLabel>
          </PieChart>)}
          
        </Box>
        <Box>
          {
            portsData?.map((item, index) => <Typography
              display={"flex"}
              justifyContent={"space-between"}
              marginBottom={2}
              key={index}
            >
              <Typography variant="subtitle" sx={{ fontSize: '12px', fontWeight: '500', color: '#5C677D' }} >{item?.label}</Typography>
              <Typography variant="subtitle" sx={{ fontSize: '12px', fontWeight: '600', color: '#001233' }}>{item?.value}</Typography>
            </Typography>)}
        </Box>
      </Box>
      {openModal &&
        (
          <>
            <CustomModal open={openModal} onClose={() => setOpenModal(false)} bgColor='white' width='50vw' overflow='clip'>
              <Grid sx={{ paddingInline: '16px' }}>
                <CustomTabs
                  formTabs={tableData?.tabs}
                  tabValue={tab}
                  handleTabChange={(e, newValue) => setTab(newValue)}
                  showCount={true}
                />
              </Grid>
              <Grid container justifyContent='flex-start' m={2}>
                <ExportExcel key='10' onClick={handleExportExcel} />
              </Grid>
              <DynamicTable
                setSelectedData={setTab}
                tabValue={tab}
                searchedData={tableData?.tabs[tab]?.table_content}
                tabs={tableData?.tabs}
                maxHeight='calc(70vh - 145px)'
              />
            </CustomModal>
          </>
        )}
    </>
  );
};

export default ChargeUsageStatue;
